"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractUserStatusEventsOfType = void 0;
function extractUserStatusEventsOfType(statusEvents, type) {
    return statusEvents.filter(statusEvent => statusEvent.type === type);
}
exports.extractUserStatusEventsOfType = extractUserStatusEventsOfType;
